import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import {
  SideCardSectionHeader,
  SideCardSectionDetail
} from '~/modules/common/components/SideCard';
import { useDialogState } from '~/modules/common/hooks';
import { ProjectTeamMemberAssignmentType } from '~/types';
import EditProjectSettingsDialog from './EditProjectSettingsDialog';

const useStyles = makeStyles(theme => ({
  detail: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary
  }
}));

const projectSettingsLabel = (
  <FormattedMessage id="projectSettingsCard.projectSettings" />
);

const getAssignmentTypeLabel = (
  projectTeamMemberAssignmentType,
  formatMessage
) => {
  if (
    projectTeamMemberAssignmentType ===
    ProjectTeamMemberAssignmentType.AutomaticallyAssignTask
  ) {
    return formatMessage({ id: 'projectSettingsCard.automaticallyAssignTask' });
  }

  return formatMessage({ id: 'projectSettingsCard.manuallyAssignTask' });
};

export const ProjectSettings = ({
  showEdit,
  projectId,
  projectTeamMemberAssignmentType
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { open, openDialog, closeDialog } = useDialogState(false, {
    disabledBackDropClick: true
  });

  return (
    <>
      <SideCardSectionHeader
        title={projectSettingsLabel}
        onEditClick={openDialog}
        dataQeId="EditProjectSettingsSection"
        showEdit={showEdit}
        ariaLabelKey="button.projectSettingsEditButton"
      />
      <SideCardSectionDetail
        classes={classes}
        detail={getAssignmentTypeLabel(
          projectTeamMemberAssignmentType,
          formatMessage
        )}
      />
      <EditProjectSettingsDialog
        open={open}
        onClose={closeDialog}
        projectId={projectId}
        projectTeamMemberAssignmentType={projectTeamMemberAssignmentType}
      />
    </>
  );
};

ProjectSettings.propTypes = {
  showEdit: PropTypes.bool,
  projectId: PropTypes.string,
  projectTeamMemberAssignmentType: PropTypes.string
};

export default ProjectSettings;
